import { Component, ElementRef, Inject, PLATFORM_ID, AfterViewInit, ViewChildren, QueryList, HostListener, OnInit } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { RouteService } from '@services/route.service';
import { ProductService } from '@services/product.service';
import { GlobalService } from '@services/global.service';
import { Product } from '@models/product';
import { environment } from '@environments/environment';

@Component({
  selector: 'gob-goldn-gob-page',
  templateUrl: './goldn-gob-page.component.html',
  styleUrls: ['./goldn-gob-page.component.scss']
})
export class GoldnGobPageComponent implements OnInit, AfterViewInit {

  @ViewChildren('listeRef') listesRefs: QueryList<ElementRef>;

  historique: any[] = [];
  historiqueBase: any[] = [];

  gammes: any[] = [];

  imageErrors: { [key: number]: boolean } = {}; // Handle image load errors for each product by its ID

  isMobile: boolean = false;
  loading: boolean = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private gServ: GlobalService,
    private pServ: ProductService,
    private location: Location,
    public route: RouteService
  ) { }

  goBack(): void {
    this.location.back();
  }
  ngOnInit(): void {
    this.loading = true;

    forkJoin({
      products: this.pServ.getSelected(),
      allGammes: this.gServ.getGammes()
    })
    .subscribe(values => {

      const goldnGobProducts = values.products.goldnGob || [];
      this.gammes = values.allGammes;

      this.processData(goldnGobProducts);
      this.updateDataDisplay();
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  /**
   * Handle image load errors for each product by its ID.
   * Set imageErrors[productId] to true when an image load error occurs.
   * @param {number} productId - The ID of the product which has an image load error.
   */
    onImageError(productId: number): void {
    this.imageErrors[productId] = true;
  }

  processData(products: Product[]) {

    const groups: { [year: string]: Product[] } = {};
    products.forEach(p => {
      p.gamme = this.gammes.find(g => g.ident === p.gamme)?.name || 'Inconnue';
      p.banners.forEach((b) => {
        if (b.name === 'Gold\'n\'Gob' && (b.start && b.start !== '0000-00-00')) {
          const d = new Date(b.start);
          if (!isNaN(d.getTime())) {
            const year = d.getFullYear().toString();
            if (!groups[year]) groups[year] = [];
            groups[year].push(p);
          }
        }
      });
    });

    // Tri
    const sortedYears = Object.keys(groups).sort((a, b) => Number(b) - Number(a));

    this.historiqueBase = sortedYears.map(year => {
      const prodsOfYear = groups[year];
      const selectedGammes = new Set<string>();

      prodsOfYear.forEach(p => {
        selectedGammes.add(p?.gamme || 'Inconnue');
      });

      const detailsStr = Array.from(selectedGammes).join(' / ');
      const nbCatStr = selectedGammes.size > 0 ? `${selectedGammes.size} catégorie${selectedGammes.size > 1 ? 's' : ''}` : '';

      return {
        annee: year,
        nbCategories: nbCatStr,
        details: detailsStr,
        jeux: prodsOfYear.map(p => this.mapProductToItem(p))
      };
    });

  }

  mapProductToItem(p: Product) {
    let cleanName = p.name;

    if (p.name) {
        cleanName = p.name.replace(/-?\s*Gold.*?202\d/i, '').trim();
        cleanName = cleanName.replace(/\s+202\d$/, '').trim();
    }

    return {
      ident: p.ident,
      nom: cleanName,
      gamme: p.gamme,
      img: this.getProductImage(p)
    };
  }

  getProductImage(prod: Product): string {
    if (prod.mainImage && prod.mainImage.name) {
      return `${environment.imgUrl}/product/${prod.mainImage.name}`;
    } else if (prod.images && prod.images.length > 0) {
      return `${environment.imgUrl}/product/${prod.images[0].name}`;
    }
    return 'assets/img/logo/logo.png';
  }

  @HostListener('window:resize')
  onResize() {
    this.updateDataDisplay();
  }

  updateDataDisplay() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 1024;
      this.historique = this.historiqueBase.map(promo => {
        if (this.isMobile) {
          const jeuxTriples = promo.jeux.length > 0
            ? [...promo.jeux, ...promo.jeux, ...promo.jeux]
            : [];
          return { ...promo, jeux: jeuxTriples };
        } else {
          return { ...promo };
        }
      });

      if (this.isMobile) {
        setTimeout(() => this.centerAllScrolls(), 100);
      }
    } else {
      this.historique = JSON.parse(JSON.stringify(this.historiqueBase));
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && this.isMobile) {
      setTimeout(() => this.centerAllScrolls(), 100);
    }
  }

  centerAllScrolls() {
    if (this.listesRefs) {
      this.listesRefs.forEach((ref) => {
        const el = ref.nativeElement;
        if (el.scrollWidth > 0) {
          el.scrollLeft = el.scrollWidth / 3;
        }
      });
    }
  }

  scrollListe(elementListe: HTMLElement, direction: 'gauche' | 'droite') {
    if (isPlatformBrowser(this.platformId)) {
      const carte = elementListe.querySelector('.jeu-item') as HTMLElement;
      const scrollAmount = carte ? carte.offsetWidth + 20 : 150;
      if (direction === 'droite') {
        elementListe.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      } else {
        elementListe.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }
    }
  }

  gererScrollInfini(event: any) {
    if (!this.isMobile) return;
    const el = event.target;
    const oneSetWidth = el.scrollWidth / 3;
    if (el.scrollLeft < 50) {
       el.scrollLeft += oneSetWidth;
    } else if (el.scrollLeft >= oneSetWidth * 2 - 20) {
       el.scrollLeft -= oneSetWidth;
    }
  }
}
